<div>
  <p class="authentication__right__card_description mb-27">
    {{ 'LOGIN.PASSWORD_RESET.CODE_DESCRIPTION' | translate }}
  </p>

  <verification-code [verificationCodeForm]="verificationCodeForm"> </verification-code>

  <p class="authentication__right__card__field-error" *ngIf="verificationCodeForm.hasError('invalid')">
    {{ 'LOGIN.PASSWORD_RESET.ERRORS.INVALID_CODE' | translate }}
  </p>
</div>
